/* External */
import {
  memo, useMemo, useCallback, useEffect,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';

/* Other */
import { getJsonImage } from 'src/theme/images';
import { hideModal, showModal } from '../../storage/modal';
import { selectShowModal } from '../../storage/modal/selectors';

/* Theme Assets */
import logoDgoGranHermano from '../../assets/svg/logos-dgo-gran-hermano.svg';

/* Components */
import Modal from '../Modal';
import ContentModal from './ContentModal';

/* Utils */
import {
  DGO_GRAN_HERMANO_TEXTS,
  STORAGE_SHOW_MODAL_GRAN_HERMANO,
} from '../../utils/constants';
import withInteractiveFocusable from '../../hocs/withInteractiveFocusable.hoc';
import {
  getProfileSelected,
  getProfilesAlreadyViewedGranHermanoModal,
} from '../../utils/profiles';

/* Styles */
import './GranHermanoModal.scss';

function GranHermanoModal() {
  const dispatch = useDispatch();
  const isModalShown = useSelector(selectShowModal);
  const profileSelected = useMemo(getProfileSelected, []);
  const profilesAlreadySeenModal = useMemo(getProfilesAlreadyViewedGranHermanoModal, []);

  const handleCloseModal = useCallback(() => {
    const newProfilesAlreadySeenModal = JSON.stringify(
      [...profilesAlreadySeenModal, profileSelected?.id],
    );

    localStorage.setItem(STORAGE_SHOW_MODAL_GRAN_HERMANO, newProfilesAlreadySeenModal);
    dispatch(hideModal());
  }, [dispatch, profileSelected, profilesAlreadySeenModal]);

  const { title, description, textButton } = DGO_GRAN_HERMANO_TEXTS.modal || {};

  useEffect(() => {
    dispatch(showModal());
  }, [dispatch]);

  return (
    <Modal
      isModalShown={isModalShown}
      backgroundOpacity
    >
      <ContentModal
        logo={getJsonImage('logos-dgo-gran-hermano') || logoDgoGranHermano}
        title={title}
        description={description}
        textButton={textButton}
        isModalShown={isModalShown}
        onEnterPress={handleCloseModal}
      />
    </Modal>
  );
}

export default memo(withInteractiveFocusable()(memo(GranHermanoModal)));
